import { render, staticRenderFns } from "./DiemPhongThuy.vue?vue&type=template&id=055c929c&"
import script from "./DiemPhongThuy.vue?vue&type=script&lang=js&"
export * from "./DiemPhongThuy.vue?vue&type=script&lang=js&"
import style0 from "./DiemPhongThuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports